import { atom } from 'recoil';

import { Atoms } from '../constants';

export type KnowledgeAttribute = {
  id: number;
  displayName: string;
  attributeName: string;
  description: string;
  // False for manually-entered attributes; they must not be offered for extraction.
  isExtractable: boolean;
  // Null when the backend does not recognise the group name — guard before use.
  attributeGroup: {
    key: string;
    value: string;
    description: string;
  } | null;
};

export const knowledgeAttributesAtom = atom<KnowledgeAttribute[]>({
  key: Atoms.knowledgeAttributes,
  default: [],
});
